var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5698_797)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#DDF5FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 10,
    height: 8,
    rx: 0.5,
    fill: "#53C4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4364 12.378C15.2062 12.1786 15.2062 11.8214 15.4364 11.622L18.1727 9.25239C18.4965 8.97196 19 9.20198 19 9.63036L19 14.3697C19 14.798 18.4965 15.0281 18.1727 14.7476L15.4364 12.378Z",
    fill: "#40A8F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5698_797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.068f57e177ba78541968c2ecd0f8b116.svg";
export { ForwardRef as ReactComponent };